import { ROUTES } from '@/constants';

const PUBLIC_ROUTES: string[] = [ROUTES.FullPaths.Login];

export default PUBLIC_ROUTES;
